import DOMPurify from 'isomorphic-dompurify';
import './link-policy';

// A legal document is the one content type here that genuinely needs structural
// headings: an 11-section policy rendered as flat paragraphs loses the outline
// screen-reader users navigate by. Kept separate from the news pipeline in
// `sanitize.ts`, whose stricter, heading-free allowlist deliberately stops an
// editor pasting an h1 into an article body.
//
// h1 is excluded on purpose — the page supplies the single h1 from a translated
// string, so the document body starts at h2 and the heading order stays valid.
const LEGAL_ALLOWED_TAGS = ['p', 'strong', 'b', 'em', 'i', 'ul', 'ol', 'li', 'a', 'br', 'h2', 'h3', 'h4'];
const LEGAL_ALLOWED_ATTR = ['href', 'target', 'rel'];

export function sanitizeLegalHtml(html: string): string {
  return DOMPurify.sanitize(html, {ALLOWED_TAGS: LEGAL_ALLOWED_TAGS, ALLOWED_ATTR: LEGAL_ALLOWED_ATTR});
}
